<template>
  <div>
    <component :is="activeErrorComponent" />
  </div>
</template>

<script>

import ExpiredLinkHandler from '@/components/auth/authErrorс/ExpiredLinkHandler.vue'
import EmailConfirmationStatusComponent from '@/components/auth/authErrorс/EmailConfirmationStatusComponent.vue'
import PageNotFoundComponent from '@/components/auth/authErrorс/PageNotFoundComponent.vue'

export default {
  name: 'AuthErrorComponents',

  data() {
    return {}
  },

  computed: {
    activeErrorComponent () {
      const queryKeys = Object.keys(this.$route.query)
      if (queryKeys.includes('notfound')) {
        return PageNotFoundComponent
      } else if (queryKeys.includes('link_expired')) {
        return ExpiredLinkHandler
      } else if (queryKeys.includes('already_confirmed')) {
        return EmailConfirmationStatusComponent
      } else {
        return null
      }
    }
  },
};
</script>
